<section class="main-content">
  <h1>{{'title.legalHold' | translate}}</h1>
  <mat-card class="no-padding">
    <section fxLayout="row" fxLayoutAlign="space-between center" class="sub-title-container">
      <p class="black-title-label">{{'title.legalHoldSub' | translate}}</p>
      <section fxLayout="row">
        <button mat-icon-button (click)="create()" class="action-icon"
                matTooltip="{{'legalHold.list.add' | translate}}"
                *ngIf="dataSource.data.length > 0 && !isAuditor()">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button class="action-icon" (click)="refresh()"
                matTooltip="{{'libraries.table.tooltips.refresh' | translate}}">
          <mat-icon>refresh</mat-icon>
        </button>
      </section>
    </section>
    <mat-tab-group *ngIf="isFinra()" (selectedIndexChange)="onHoldTypeTabChange($event)">
      <mat-tab label="{{'legalHold.list.tabs.standard' | translate}}"></mat-tab>
      <mat-tab label="{{'legalHold.list.tabs.finra' | translate}}"></mat-tab>
    </mat-tab-group>
    <div class="spinner-container" *ngIf="loading$ | async">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <section [hidden]="loading$ | async">
      <section fxLayout="column" fxLayoutAlign="start" class="no-holds-container" *ngIf="dataSource.data.length === 0 && !isAuditor()">
        <p class="grey-label">{{'legalHold.list.noHolds' | translate}}</p>
        <button mat-button (click)="create()"
                class="new-hold-btn">  {{'legalHold.list.newHoldButton'|translate}}</button>
      </section>
      <section fxLayout="row" fxLayoutAlign="start">

        <table mat-table [dataSource]="dataSource" id="legal-hold-table" class="mat-elevation-z8"
               [hidden]="dataSource.data.length === 0">

          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef><span>{{'legalHold.list.table.label' | translate}}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"><span>{{element.id}}</span>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef><span>{{'legalHold.list.table.created'  | translate}}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"><span> {{element.created | date: 'dd/MM/yyyy'}}  </span>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="rules">
            <mat-header-cell *matHeaderCellDef>{{'legalHold.list.table.rules' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"><span>  {{convertRules(element.rules)}}</span></mat-cell>
          </ng-container>


          <ng-container matColumnDef="documents">
            <mat-header-cell *matHeaderCellDef><span>{{'legalHold.list.table.documents'| translate}}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{processedCount(element)}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="failed">
            <mat-header-cell *matHeaderCellDef><span>{{'legalHold.list.table.failed'| translate}}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [class.failed-count]="failedCount(element) > 0">{{failedCount(element) > 0 ? failedCount(element) : 0}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef><span>{{'legalHold.list.table.status'| translate}}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [class.status-in-progress]="isInProgress(element)"
                    [class.status-done]="element.status === 'APPLIED' || element.status === 'RELEASED'"
                    [class.status-failed]="element.status === 'FAILED'"
                    [class.status-warning]="isWithErrors(element)">
                {{getStatusLabel(element)}}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <button mat-button mat-icon-button (click)="view(element)"
                      [disabled]="element.status === 'RELEASED' || element.status === 'RELEASED_WITH_ERRORS'"
                      *ngIf="!isAuditor()"
                      class="table-button">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns();"></mat-row>
        </table>
      </section>
      <section [hidden]="dataSource.data.length === 0">
        <mat-paginator [pageSizeOptions]="[10,20,30]"></mat-paginator>
      </section>
    </section>
  </mat-card>
</section>
